import { theme, IconButton as IB } from "@local-logic/core/ui";
import { styled } from "styled-components";
import { Search } from "~/components/Search/styles";

export const CommuteCalculatorContainer = styled.div`
  max-height: calc(100% - 2 * ${theme["--ll-spacing-medium"]});
  border-radius: ${theme["--ll-border-radius-medium"]};
  box-shadow: ${theme["--ll-shadow-small"]};
  background-color: ${theme["--ll-color-background"]};
  border: 1px solid ${theme["--ll-color-border"]};
  padding: ${theme["--ll-spacing-x-small"]};
`;

export const CommuteSearch = styled.div`
  display: flex;
  justify-content: space-between;

  ${Search} {
    // Adjust if text of commute transport mode changes
    width: 52%;
    margin-right: ${theme["--ll-spacing-x-small"]};
  }
`;

export const CommuteInfo = styled.div`
  background-color: ${theme["--ll-color-surface"]};
  padding: ${theme["--ll-spacing-x-small"]} ${theme["--ll-spacing-small"]} 0;
  border-radius: ${theme["--ll-border-radius-medium"]};
`;

export const IconButton = styled(IB)`
  position: absolute;
  right: ${theme["--ll-spacing-xx-small"]};
  top: ${theme["--ll-spacing-xx-small"]};
`;

export const SelectContainer = styled.div`
  width: 150px;
  display: flex;
  align-items: flex-end;
  button {
    width: 100%;
  }
`;
